import i18n from '@i18n';
import * as yup from 'yup';

export const validationSchema = () =>
  yup.object({
    name: yup.string().required(i18n.t('VALIDATION.NAME.REQUIRED')),
    organizer_id: yup
      .number()
      .required(i18n.t('VALIDATION.REQUIRED'))
      .nullable(true),
    person_charge_id: yup
      .number()
      .required(i18n.t('VALIDATION.REQUIRED'))
      .nullable(true),
    date_start_event: yup.string().required(i18n.t('VALIDATION.REQUIRED')),
    date_finish_event: yup.string().required(i18n.t('VALIDATION.REQUIRED')),
  });
